<template>
  <div class="container">
    <ul class="account-nav">
      <li
        v-for="(item, idx) in items"
        class="account-nav__item"
        :key="'accountnav-' + item.to"
      >
        <ui-button
          :icon="item.icon"
          :to="{ name: item.to }"
          :key="'accountnav' + idx"
          icon-size="1.4em"
          size="m"
          text
          markup="router-link"
          :color="$route.name == item.to ? 'primary' : 'black'"
          >{{ item.label }}</ui-button
        >
      </li>
      <li class="account-nav__item">
        <ui-button
          @click="signOut"
          icon="arrow-out-circle"
          icon-size="1.4em"
          size="m"
          text
          >Déconnexion</ui-button
        >
      </li>
    </ul>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
import UserStore from "@/store/userStore";
export default {
  components: { UiButton },
  data() {
    return {
      items: [
        { to: "account", label: "Paramètres", icon: "sliders" },
        { to: "favorites", label: "Favoris", icon: "bookmark" },
      ],
    };
  },
  methods: {
    signOut() {
      UserStore.commit("signOut");
      this.$router.push("/");
    },
  },
};
</script>
<style lang="scss">
.account-nav {
  list-style: none;
  margin: 15px 0 0 0;
  padding: 5px;
  box-shadow: $box-shadow;
  border-radius: $radius;
  display: flex;
  &__item {
    padding: 10px 20px;
    & + & {
      border-left: 1px solid rgba($light-gray, 0.5);
    }
    svg {
      stroke-width: 1px;
      margin-right: 0.5em !important;
    }
  }
}
</style>
